import { Component, inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IAuctionListing } from '../../../../models/IAuctionListing';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { TimeLeftService } from '../../../../services/time-left.service';
import { CommonModule } from '@angular/common';
import { DateFormatService } from '../../../../services/date-format/date-format.service';
import { SanitizeHtmlTextPipe } from '../../../../shared/pipes/sanitize-html-text.pipe';
import { faBookmark as faBookmarkSolid } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Subscription } from 'rxjs';
import { AuthService, LOGIN_TYPE_TOPBAR } from '../../../../services/authentication/auth.service';
import { MyAuctionsService } from '../../../../services/bidder-community/my-auctions/my-auctions.service';
import { AuctionListingService } from '../../../../services/bidder-community/auction-listing/auction-listing.service';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-auction-listing-horizontal-view',
  imports: [FontAwesomeModule,
    CommonModule,
    SanitizeHtmlTextPipe,
    RouterModule],
  templateUrl: './auction-listing-horizontal-view.component.html',
  styleUrl: './auction-listing-horizontal-view.component.scss'
})
export class AuctionListingHorizontalViewComponent implements OnInit {

  @Input() auctions: IAuctionListing[] | null = null;

  absoluteMediaUriService = inject(AbsoluteMediaUriService);
  timeLeftService = inject(TimeLeftService);
  dateFormatService = inject(DateFormatService);
  oidcSecurityService = inject(OidcSecurityService);
  authService = inject(AuthService);
  myAuctionService = inject(MyAuctionsService);
  auctionListingService = inject(AuctionListingService);

  isAuthenticated = this.oidcSecurityService.authenticated;
  // private readonly platformId = inject(PLATFORM_ID);
  authSubscription!: Subscription;


  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;
  faLocationDot = faLocationDot;

  @Output() myAuctionChanged = new EventEmitter<IAuctionListing | null>();




  ngOnInit(): void {
    //  this.authSubscription = this.authService.isAuthenticated$.pipe(distinctUntilChanged()).subscribe(isAuth => {
    //   if (isAuth) {
    //     this.auctionListingService.getAuctionListing(this.filters()).subscribe();

    //   } else {
    //     if (isPlatformBrowser(this.platformId)) {
    //       this.clearFilters()
    //       this.auctionListingService.getAuctionListing(this.filters()).subscribe();

    //     }
    //   }
    // });
  }


  smartTitleCase(text: string): string {
    const lower = [
      'of', 'and', 'the', 'in', 'on', 'at', 'for', 'a', 'an', 'to'
    ];

    return text
      .toLocaleLowerCase()
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }

        return lower.includes(word)
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
  }

  isImage(value: string | null | undefined): boolean {
    if (!value) return false;

    return /\.(jpg|jpeg|png|webp|gif)$/i.test(value);
  }

  toggleFavorite(myAuction: IAuctionListing): void {

    if (!this.isAuthenticated().isAuthenticated) {
      this.openLoginModal(() => {
        this.onHandlerMyAuction(myAuction);
      });
    } else {
      this.onHandlerMyAuction(myAuction);
    }
  }

  onHandlerMyAuction(myAuction: IAuctionListing) {
    if (myAuction.isFavorite) {
      this.myAuctionService.deleteAuction(myAuction.auctionId).subscribe({
        next: () => this.myAuctionChanged.emit(myAuction)
      });
    } else {
      this.myAuctionService.putMyAuction(myAuction.auctionId).subscribe({
        next: () => this.myAuctionChanged.emit(myAuction)
      });
    }
  }

  openLoginModal(fun?: () => void) {
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun ?? (() => { })
    );
  }

  protected getAuctionUrl(auction: IAuctionListing): string {
    if (auction.isUsing2025Design) {
      return '/auction/' + auction.auctionId;
    } else {
      return this.absoluteMediaUriService.getAbsoluteMediaUri(
        '/auction/auctionhome.action?auctionId=' + auction.auctionId
      );
    }
  }

}
